import { useEffect, useState } from "react";
import ApiEngine from "../../util/ApiEngine.js";
import {
    ApiKey,
    ApiUrl,
    WebUrl,
    SessionKey,
    TransactionStatus,
} from "../../util/Constant";

export const useUTM = () => {
    const [utm, setUtm] = useState({});

    // Read UTM from URL
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        ;
        const data = {
            utm_source: params.get("utm_source") || "",
            utm_medium: params.get("utm_medium") || "",
            utm_campaign: params.get("utm_campaign") || "",
            utm_content: params.get("utm_content") || "",
            utm_term: params.get("utm_term") || ""
        };
        // Only landings that carry campaign data need the server round trip.
        if (Object.values(data).some(v => v !== "")) {
            captureData(data);
        }
        setUtm(data);
    }, []);

    // Save to localStorage
    useEffect(() => {
        if (Object.values(utm).some(v => v !== "")) {
            localStorage.setItem("utm_data", JSON.stringify(utm));
        }
    }, [utm]);

    // Push to GTM
    useEffect(() => {
        
        
        if (window.dataLayer && utm.utm_source) {
            window.dataLayer.push({
                event: "utm_data",
                ...utm
            });
        }
    }, [utm]);

    async function captureData(data) {

        const utms = new URLSearchParams(data);
        var responseJson2 = await ApiEngine.get(
            ApiUrl._API_CAPTURE_UTM +"?" + utms.toString()
        );
    }

    return utm;
};
